/* eslint-disable no-return-assign */
import { ArrowDown } from 'assets/icons'

import { Disclosure, Transition } from '@headlessui/react'

interface CustomDisclosureProps {
  id: string
  qn: string
  ans: string | JSX.Element
  className?: string
}

const CustomDisclosure = ({
  id,
  qn,
  ans,
  className = ''
}: CustomDisclosureProps) => (
  <Disclosure
    as='div'
    className='bg-white shadow-card border border-gray-500 p-3 rounded-lg w-full'
    key={id}
  >
    {({ open }) => (
      <>
        <Disclosure.Button
          id={id}
          className={`cursor-pointer w-full overflow-hidden ${className}`}
        >
          <div className='flex flex-row gap-3 justify-between items-center'>
            <p className='text-left leading-5 text-xs font-bold w-full text-purple-900 md:px-0'>
              {qn}
            </p>
            <span className='rounded-full shrink-0 flex items-center justify-center border border-gray-300 h-6 w-6'>
              <ArrowDown
                className={` ${
                  open
                    ? 'rotate-180 transform duration-300'
                    : 'transform duration-300'
                }`}
              />
            </span>
          </div>
        </Disclosure.Button>
        <Transition
          enter='transition duration-200 ease-out'
          enterFrom='transform scale-95 opacity-0'
          enterTo='transform scale-100 opacity-100'
          leave='transition duration-200 ease-out'
          leaveFrom='transform scale-100 opacity-100'
          leaveTo='transform scale-95 opacity-0'
        >
          <Disclosure.Panel
            className='text-black text-xs overflow-hidden'
            static
          >
            <p className='leading-5 mt-2'>{ans}</p>
          </Disclosure.Panel>
        </Transition>
      </>
    )}
  </Disclosure>
)

export default CustomDisclosure
